import { useState } from 'react';

import { Radio } from '@iwoca/orion';

import styles from './BankStatements.module.css';
import ManualUploadUK from './ManualUpload';
import { useGetContext } from '../../../../../lendingApi/lendingApiQueries';
import {
  TOfferDataRequirement,
  TTrueLayerAlertStatus,
} from '../../../../../types';
import Required from '../../../DocumentRequirement/Required';
import TrueLayer from '../../../TrueLayer/TrueLayer';
import { getLinkedBankAccountDetails } from '../../../TrueLayer/trueLayer.helpers';
import TrueLayerAlertBox from '../../../TrueLayer/TrueLayerAlertBox/TrueLayerAlertBox';
import TrueLayerLinkedAccount from '../../../TrueLayer/TrueLayerLinkedAccount/TrueLayerLinkedAccount';

type TProps = {
  quantifier: number;
  status?: TOfferDataRequirement['actions'][number]['status'];
  isSubmitted: boolean;
  resolutionMethods: TOfferDataRequirement['actions'][number]['resolution_methods'];
};

const BankStatementsUK = ({
  quantifier,
  status,
  isSubmitted,
  resolutionMethods,
}: TProps) => {
  const [requirementType, setRequirementType] = useState('bank_account');

  const [trueLayerAlertStatus, setTrueLayerAlertStatus] =
    useState<TTrueLayerAlertStatus>(null);

  const { context } = useGetContext();

  const REQUIREMENTS = [
    { header: 'Link my bank account', value: 'bank_account' },
    { header: 'Add business bank statements', value: 'manual' },
  ];

  const renderRequirements = () => {
    switch (requirementType) {
      case 'bank_account':
        return <TrueLayer setAlertStatus={setTrueLayerAlertStatus} />;
      case 'manual':
        return (
          <ManualUploadUK
            title={title}
            status={status}
            isSubmitted={isSubmitted}
          />
        );
    }
  };

  const title = `Business bank statements for the last ${
    quantifier > 1 ? `${quantifier} months` : '1 month'
  } (from today)`;

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        {/* id has space instead of hyphen to match other dynamic ids used for scrolling to requirements */}
        <h4 className={styles.title} id="document-requirement-bank statement">
          {title}
          {isSubmitted && (status === 'required' || status === 'error') && (
            <Required />
          )}
        </h4>
        <h5 className={styles.subTitle}>
          Select the method you’d like to provide bank statements
        </h5>
      </div>
      {REQUIREMENTS.map((requirement) => (
        <div className={styles.radioSection} key={requirement.value}>
          <Radio
            label={requirement.header}
            onChange={() => setRequirementType(requirement.value)}
            checked={requirementType === requirement.value}
            frame
          />
        </div>
      ))}
      {renderRequirements()}
      {trueLayerAlertStatus && (
        <TrueLayerAlertBox status={trueLayerAlertStatus} />
      )}
      <TrueLayerLinkedAccount
        linkedBankAccount={getLinkedBankAccountDetails(
          resolutionMethods,
          context,
        )}
      />
    </div>
  );
};

export default BankStatementsUK;
